/* eg-lymph-reviews — the review rail, looping.

   The rail is a native scroll-snap strip, so swiping works on its own. To make
   it endless the whole set is cloned once before and once after the real cards;
   when the scroll settles inside a clone set the rail is shifted back by one
   set's width, which is invisible because the clones are identical. The arrows
   move one card at a time and never run out of rail.

   The photo marquee above is pure CSS and takes no part in this. */
(function () {
  'use strict';

  var SETTLE = 120;

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (!root || root.dataset.lfrInit === 'true') return;
    root.dataset.lfrInit = 'true';

    var rail = root.querySelector('[data-lfr-rail]');
    var prev = root.querySelector('[data-lfr-prev]');
    var next = root.querySelector('[data-lfr-next]');
    if (!rail) return;

    var cards = slice(rail.querySelectorAll('[data-lfr-card]'));
    if (!cards.length) return;

    /* ---- the loop: a copy of the set on each side of the real cards ---- */
    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    cards.forEach(function (card) {
      [before, after].forEach(function (target) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.lfrClone = 'true';
        target.appendChild(clone);
      });
    });
    rail.insertBefore(before, rail.firstChild);
    rail.appendChild(after);

    function items() {
      return rail.querySelectorAll('[data-lfr-card]');
    }

    /* The scroll position that brings a card to its snap point. Measured from
       the rendered boxes, so it holds wherever the rail sits in the layout:
       mobile centres a card, desktop lines it up with the rail's left edge. */
    function offsetFor(item) {
      var railBox = rail.getBoundingClientRect();
      var itemBox = item.getBoundingClientRect();
      var at = rail.scrollLeft;
      if (getComputedStyle(item).scrollSnapAlign.indexOf('center') !== -1) {
        return at + (itemBox.left + itemBox.width / 2) - (railBox.left + railBox.width / 2);
      }
      return at + itemBox.left - railBox.left - parseFloat(getComputedStyle(rail).paddingLeft);
    }

    function nearest() {
      var list = items();
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var dist = Math.abs(offsetFor(list[i]) - rail.scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return { items: list, index: best, per: list.length / 3 };
    }

    function goTo(index, instant) {
      var list = items();
      var i = Math.max(0, Math.min(list.length - 1, index));
      rail.scrollTo({ left: offsetFor(list[i]), behavior: instant ? 'auto' : 'smooth' });
    }

    function jump(by) {
      var behavior = rail.style.scrollBehavior;
      rail.style.scrollBehavior = 'auto';
      rail.scrollLeft += by;
      rail.style.scrollBehavior = behavior;
    }

    /* Shift back to the real set once the scroll has settled — "settled"
       meaning the position stopped changing, because moving the rail mid
       animation would fight the smooth scroll. */
    var settle;
    var lastSeen = null;

    function recentre() {
      if (rail.scrollLeft !== lastSeen) {
        lastSeen = rail.scrollLeft;
        settle = setTimeout(recentre, SETTLE);
        return;
      }
      var at = nearest();
      var width = offsetFor(at.items[at.per]) - offsetFor(at.items[0]);
      if (width <= 0) return;
      if (at.index < at.per) jump(width);
      else if (at.index >= at.per * 2) jump(-width);
    }

    function sync() {
      clearTimeout(settle);
      lastSeen = null;
      settle = setTimeout(recentre, SETTLE);
    }

    var pending;
    function request() {
      clearTimeout(pending);
      pending = setTimeout(sync, 60);
    }

    if (prev) {
      prev.disabled = false;
      prev.addEventListener('click', function () {
        goTo(nearest().index - 1);
      });
    }
    if (next) {
      next.disabled = false;
      next.addEventListener('click', function () {
        goTo(nearest().index + 1);
      });
    }

    rail.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () {
      goTo(nearest().index, true);
    });

    // start on the first card of the middle set, without animating the jump
    goTo(nearest().per, true);
    sync();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-lfr]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
